// extracted by mini-css-extract-plugin
module.exports = {"login":"LogoutButton_login__l2xAo","logout":"LogoutButton_logout__flKpN"};